module.exports = __webpack_public_path__ + "img/Chiu.28f714a7.png";